export default "__VITE_ASSET__BY$h2B59__"